var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "none",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "scale(6.4,6.4)",
    d: "M35,39h-34v-34l26,0l-4,-4h16v16l-4,-4z",
    id: "strokeMainSVG",
    fill: "#976821",
    stroke: "#976821",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(6.4,6.4)",
    stroke: "none",
    strokeLinejoin: "miter"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5,5.5h33v33h-33z",
    fill: "#feefd7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,6v32h-32v-32h32M35,5h-34v34h34v-34z",
    fill: "#976821"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(48.611,-19.055) rotate(90)",
    d: "M30.611,13.611h6.444v2.333h-6.444z",
    fill: "#feefd7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,5h6.444v2.333h-6.444z",
    fill: "#feefd7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.707,16l10,-10l-4.5,-4.5h14.293v14.293l-4.5,-4.5l-10,10z",
    fill: "#feefd7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,2v12.586l-3.293,-3.293l-0.707,-0.707l-0.707,0.707l-9.293,9.293l-4.586,-4.586l9.293,-9.293l0.707,-0.707l-0.707,-0.707l-3.293,-3.293h12.586M39,1h-16l5,5l-10,10l6,6l10,-10l5,5v-16z",
    fill: "#976821"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.9b973c07.svg";
export { ForwardRef as ReactComponent };